import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import { useDispatch } from 'react-redux';

const logger = createLogger();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: true }).concat(logger),
});

// Define RootState as the return type of the rootReducer
export type RootState = ReturnType<typeof store.getState>;

// Define AppDispatch as the type of the store's dispatch function
export type AppDispatch = typeof store.dispatch;

// Define AppThunk for thunk actions
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

// Create a custom `useAppDispatch` hook to use throughout the app
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;